import React from 'react';

import NavBar from '../NavBar/NavBar';
import Content from './Content';
import { FlexDiv, RightSection } from 'commonStyles';
import { ContentSectionWrap } from './ContentStyle';
import SectionHeader from '../SectionHeader/SectionHeader';

export const ContentSection = ({ activeSection, contentData = {}, updateActiveSection, scrollRef }) => {
	const { leftSection = {}, rightSection = {} } = contentData;
	const { styles = {} } = rightSection;

	return (
		<ContentSectionWrap ref={scrollRef} position='sticky'>
			<NavBar nav={leftSection.nav} activeSection={activeSection} updateActiveSection={updateActiveSection} />
			<RightSection $width='calc(100% - 210px)'>
				{rightSection.sectionHeader && <SectionHeader {...rightSection.sectionHeader} />}
				<FlexDiv
					bottom_M={styles.bottom_M || '750'}
					left_P={styles.left_P || '24'}>
					{rightSection.content?.length > 0 && <Content isSection content={rightSection.content} nav={leftSection.nav} />}
				</FlexDiv>
			</RightSection>
		</ContentSectionWrap>
	);
};

export default ContentSection;
